<template>
  <a class="discret --text-is-gray bigText" href="https://scalingo.com/">Scalingo</a>
</template>

<script>
export default {
  name: 'ScalingoLink'
}
</script>

<style scoped>

</style>
